import type { Workflow } from '../types';

const KEY = 'iiq.workflow-builder.workflows.v1';
const ACTIVE_KEY = 'iiq.workflow-builder.active.v1';

export function listWorkflows(): Workflow[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    return JSON.parse(raw) as Workflow[];
  } catch {
    return [];
  }
}

export function saveWorkflow(wf: Workflow): void {
  const all = listWorkflows();
  const idx = all.findIndex(w => w.id === wf.id);
  const next = { ...wf, updatedAt: Date.now(), version: wf.version + 1 };
  if (idx >= 0) all[idx] = next;
  else all.push(next);
  localStorage.setItem(KEY, JSON.stringify(all));
}

export function deleteWorkflow(id: string): void {
  const all = listWorkflows().filter(w => w.id !== id);
  localStorage.setItem(KEY, JSON.stringify(all));
}

export function getActiveWorkflowId(): string | null {
  return localStorage.getItem(ACTIVE_KEY);
}

export function setActiveWorkflowId(id: string): void {
  localStorage.setItem(ACTIVE_KEY, id);
}

export function exportWorkflow(wf: Workflow): string {
  return JSON.stringify(wf, null, 2);
}

export function importWorkflow(json: string): Workflow {
  const parsed = JSON.parse(json);
  if (!parsed.id || !parsed.nodes || !parsed.edges) {
    throw new Error('Invalid workflow JSON — missing id / nodes / edges');
  }
  return parsed as Workflow;
}
